import React, { useEffect, useState } from "react";

const Loding = () => {
  return (
    <div>
      <h1 className="text-center mt-10 mx-52 text-slate-800 md:text-4xl sm:border-x-8 border sm:border-y-0 md:border-x-8 md:border-y-0 border text-purple-800">
        Please Wait Data is Loading <span> </span>
      </h1>
    </div>
  );
};

export default Loding;
